import { AppError } from './AppError';

export class AuthenticationError extends AppError {
  constructor(message: string, code: string = 'UNKNOWN_AUTHENTICATION_ERROR') {
    super(message, code);
    this.name = 'AuthenticationError';
  }
}